import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";

export const AboutSheet = ({ open, onOpenChange }) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent data-testid="about-sheet" className="overflow-y-auto sm:max-w-md" style={{ background: "var(--surface)" }}>
      <SheetHeader>
        <SheetTitle className="font-display flex items-center gap-2.5">
          <img src="/logo192.png" alt="" className="h-8 w-8" /> About RGA Trainer
        </SheetTitle>
      </SheetHeader>
      <div data-testid="about-text" className="mt-4 space-y-4 text-sm leading-relaxed" style={{ color: "var(--ink-2)" }}>
        <p>RGA Trainer is a free study aid developed by a current RGA Trainee to assist with preparation for the SSSA exam. It is designed to mimic the formal exam template, with allowances for reading time and reminders for candidates to move on to the next question at appropriate intervals.</p>
        <p>The cases, content and format have been modelled in conjunction with ANZCA's relevant publications, including the RGA Handbook and SSSA Sample Exam Questions. Please note that AI has been utilised in the development of this web app, and as such there is the potential for errors or inaccuracies. All clinical information, advice and feedback is provided as a guide only and candidates are encouraged to cross-reference these with their own study material.</p>
      </div>
    </SheetContent>
  </Sheet>
);
